import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';

import {
    RadialChart,
    Hint
} from 'react-vis';

const styles = {
    hint: {
        background: 'black',
        borderRadius: '5px',
        padding: '2px',
        color: 'white',
        textAlign: 'center'
    },
    pie: {
        margin: 'auto'
    }
};

class AbstractPieChart extends Component {
    state = {
        hover: undefined
    };

    onHover = (hover) => {
        this.setState({ hover });
    }

    hoverStop = () => {
        this.setState({ hover: undefined });
    }

    render() {
        const { hover } = this.state;
        const { classes, values, color } = this.props;
        return (
            <RadialChart
                data={values.filter(value => value.angle > 0)}
                innerRadius={100}
                radius={140}
                width={300}
                height={300}
                onValueMouseOver={this.onHover}
                onSeriesMouseOut={this.hoverStop}
                className={classes.pie}
                colorType={color ? 'literal' : undefined}
            >
                {hover && <Hint value={hover}>
                    <div style={styles.hint}>
                        {hover.label}: {hover.count}
                    </div>
                </Hint>}
            </RadialChart>
        );
    }
}

export default withStyles(styles)(AbstractPieChart);